// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"e42d7347","453":"9687b281","796":"33812ff2"}[chunkId] + ".chunk.js";
};